import React, { useState } from 'react';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import "assets/css/booking3.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import "assets/css/CardSectionStyles.css";

const BookingStep4 = ({ show, onHide, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const stripe = useStripe();
  const elements = useElements();

  const validationSchema = Yup.object({
    cardholderName: Yup.string().required('Cardholder name is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      if (!stripe || !elements) {
        return;
      }

      const { token, error } = await stripe.createToken(elements.getElement(CardNumberElement));
      
      if (error) {
        setError(error.message);
        setLoading(false);
      } else {
        onSubmit({
          cardholderName: values.cardholderName,
          cardNumber: token.card.last4,
          expirationDate: `${token.card.exp_month}/${token.card.exp_year}`,
          token: token.id
        });
        setLoading(false);
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
    setSubmitting(false);
  };

  if (!show) return null;
  return (
    <div className="stripe-modal fixed inset-0 flex items-center justify-center">
      <div className="stripe-card">
        <div className="stripe-header">
          <h3 className="stripe-title">Add card</h3>
          <button className="stripe-close" onClick={onHide}>×</button>
        </div>

        <Formik
          initialValues={{ cardholderName: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <div className="stripe-form-group">
                <label className="stripe-label">Cardholder name</label>
                <Field
                  type="text"
                  name="cardholderName"
                  className={`stripe-input ${
                    errors.cardholderName && touched.cardholderName ? 'is-invalid' : ''
                  }`}
                  placeholder="Juanita Simmmons"
                />
                <ErrorMessage name="cardholderName" component="div" className="invalid-feedback" />
              </div>

              <div className="stripe-form-group">
                <label className="stripe-label">Card number</label>
                <CardNumberElement
                  className="stripe-input"
                  options={{
                    style: {
                      base: {
                        fontSize: '16px',
                        color: '#32325d',
                        fontFamily: 'Arial, sans-serif',
                        '::placeholder': {
                          color: '#aab7c4',
                        },
                      },
                      invalid: {
                        color: '#fa755a',
                      },
                    },
                  }}
                />
              </div>

              <div className="stripe-row">
                <div className="stripe-form-group">
                  <label className="stripe-label">Expiration date</label>
                  <CardExpiryElement
                    className="stripe-input"
                    options={{
                      style: {
                        base: {
                          fontSize: '16px',
                          color: '#32325d',
                          fontFamily: 'Arial, sans-serif',
                          '::placeholder': {
                            color: '#aab7c4',
                          },
                        },
                        invalid: {
                          color: '#fa755a',
                        },
                      },
                    }}
                  />
                </div>

                <div className="stripe-form-group">
                  <label className="stripe-label">CVV</label>
                  <CardCvcElement
                    className="stripe-input"
                    options={{
                      style: {
                        base: {
                          fontSize: '16px',
                          color: '#32325d',
                          fontFamily: 'Arial, sans-serif',
                          '::placeholder': {
                            color: '#aab7c4',
                          },
                        },
                        invalid: {
                          color: '#fa755a',
                        },
                      },
                    }}
                  />
                </div>
              </div>

              <button type="submit" className="stripe-submit">
                Add card
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default BookingStep4;